import { useCookies } from 'react-cookie';
import { domain, LocationCookie, ZipCodeCookie, PersistentZipCodeCookie } from '../utils/constants';
import * as locationParser from '../utils/locationParser';
import { useMemo, useCallback } from 'react';
export default () => {
  const [cookies, setCookie] = useCookies([LocationCookie]);
  const locationCookieValue = cookies[LocationCookie];
  const globapZipInfo = useMemo(() => locationParser.decode(locationCookieValue), [locationCookieValue]);
  const FIRST_DATE = new Date(0);
  const updateGlobalZip = useCallback(newGlobalZipInfo => {
    const cookieValue = locationParser.encode(newGlobalZipInfo);
    setCookie(LocationCookie, cookieValue, {
      domain,
      path: '/'
    });
    setCookie(ZipCodeCookie, newGlobalZipInfo.zip, {
      expires: FIRST_DATE
    });
    setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, {
      expires: FIRST_DATE
    });
    const cookieAge = 60 * 60 * 24 * 30;
    const now = new Date();
    const expirationDate = new Date(now.valueOf() + cookieAge * 1000);
    const cookieOptionsForZipCode = {
      path: '/',
      maxAge: cookieAge,
      expires: expirationDate
    };
    setCookie(ZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
    setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
  }, [setCookie]);
  return {
    globalZip: globapZipInfo.zip,
    userInputZip: globapZipInfo.zip,
    globalZipInfo: globapZipInfo,
    updateGlobalZip
  };
};